import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import { INSET_PX, SIDEBAR_MAX_WIDTH_PX, SIDEBAR_MIN_WIDTH_PX, SIDEBAR_WIDTH_PX } from './constants';
// Sidebar width state and left-edge resize handling, isolated from the
// floating variant's drag/resize/fullscreen logic in useFloatingGeometry.
export function useSidebarGeometry(_ref) {
  var startDrag = _ref.startDrag,
    isActive = _ref.isActive;
  var _useState = useState(SIDEBAR_WIDTH_PX),
    _useState2 = _slicedToArray(_useState, 2),
    sidebarWidth = _useState2[0],
    setSidebarWidth = _useState2[1];
  var startSidebarWidthDrag = useCallback(function (e) {
    var startX = e.clientX;
    var startWidth = sidebarWidth;
    var maxWidth = Math.min(SIDEBAR_MAX_WIDTH_PX, window.innerWidth - INSET_PX);
    startDrag(e, function (ev) {
      setSidebarWidth(Math.max(SIDEBAR_MIN_WIDTH_PX, Math.min(maxWidth, startWidth + (startX - ev.clientX))));
    });
  }, [sidebarWidth, startDrag]);
  useEffect(function () {
    if (!isActive) return;
    function onResize() {
      var maxAllowed = Math.min(SIDEBAR_MAX_WIDTH_PX, window.innerWidth - INSET_PX);
      var minAllowed = Math.min(SIDEBAR_MIN_WIDTH_PX, maxAllowed);
      setSidebarWidth(function (w) {
        return Math.min(Math.max(w, minAllowed), maxAllowed);
      });
    }
    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, [isActive]);
  return {
    sidebarWidth: sidebarWidth,
    startSidebarWidthDrag: startSidebarWidthDrag
  };
}